<template>
  <div>
    <div v-if="item.regular_price" class="small text-muted text-line-through">{{ item.regular_price | numberToRs }}</div>
    <div v-if="canOverrideSellingPrice && editing" class="input-group">
      <input v-if="canOverrideSellingPrice" type="text" class="form-control text-right" :value="item.price" @change="updatePrice" :disabled="processing">
      <div class="input-group-append">
        <button type="button" class="btn btn-outline-secondary" @click.prevent="editing = !editing" :disabled="processing">
          <i v-if="processing" class="fas fa-circle-notch fa-spin"></i>
          <i v-else class="fa fa-times"></i>
        </button>
      </div>
    </div>
    <template v-else>
      <span>{{ item.price | numberToRs }}</span>
      <button v-if="canOverrideSellingPrice" type="button" class="btn btn-outline-primary" @click.prevent="editing = !editing" :disabled="processing">
        <i v-if="processing" class="fas fa-circle-notch fa-spin"></i>
        <i v-else class="fa fa-edit"></i>
      </button>
      <div v-if="item.original_price" class="text-muted small">Originally {{ item.original_price | numberToRs }}</div>
    </template>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'SaleCartSellingPrice',
  props: [
    'cart_id',
    'item',
    'canOverrideSellingPrice'
  ],
  data () {
    return {
      editing: false,
      processing: false
    }
  },
  methods: {
    updatePrice: function (e) {
      this.processing = true

      axios.patch(process.env.URLS_POS_API + '/cart/' + this.cart_id + '/products/' + this.item.key, {
        price: e.target.value,
        include_cart: true
      }).then((response) => {
        this.editing = false
        this.$parent.$parent.cart = response.data.data.cart
      }).catch(error => {
        this.$toast.error('Failed to update the product. ' + typeof error.response !== 'undefined' && typeof error.response.data.message !== 'undefined' ? error.response.data.message : null)
      }).finally(() => {
        this.processing = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/sale/partials/cart/SellingPrice.vue